'use strict';

angular.module('internal.investigations')
    .controller('InternalInvestigationMonitoringModal', [
        '$scope',
        '$uibModalInstance',
        'monitoringEntries',
        function ($scope, $uibModalInstance, monitoringEntries) {
            $scope.complaint_monitoring = monitoringEntries;
            $scope.loading = false;

            $scope.checkDue = function (complaint_action) {
                var due = false;
                var today = new Date();
                if (complaint_action.due_date !== null &&
                    complaint_action.complete_date == null &&
                    complaint_action.due_date < today) {
                    due = true;
                }
                return due;
            };

            $scope.closeModal = function () {
                $uibModalInstance.close();
            };
        }
    ]);